import React from 'react';
import ResponsiveTable from '../ReusableComponents/ResponsiveTable';
import './AnswerKeysPreview.css';

export default function AnswerKeysPreview({ rows, headings, processLabel }) {
    return <div className="answer-keys-preview">
        <ResponsiveTable className="table table-striped answer-keys-table" aria-label="Gabaritos das provas objetivas">
            <colgroup><col className="answer-key-process-column" /><col className="answer-key-exam-column" /><col /></colgroup>
            <thead><tr><th>{processLabel}</th><th>Prova</th><th>Gabarito por questão</th></tr></thead>
            <tbody>{rows.map((row, rowIndex) => <tr key={rowIndex}>
                <td data-label={processLabel}><span className="answer-key-name">{row[0] || '—'}</span></td>
                <td data-label="Prova"><span className="answer-key-name">{row[1] || '—'}</span></td>
                <td data-label="Gabarito por questão">
                    {row.length > 2 ? <div className="answer-key-grid">{row.slice(2).map((answer, index) => {
                        const label = headings[index + 2] || `Questão ${index + 1}`;
                        return <div className="answer-key-item" key={index} aria-label={`${label}: ${answer || 'Sem gabarito'}`}>
                            <span className="answer-key-number">Q{index + 1}</span>
                            <strong className={answer && answer !== '-' ? 'answer-key-value' : 'answer-key-value is-empty'}>{answer || '—'}</strong>
                        </div>;
                    })}</div> : <span className="text-muted">Nenhuma questão objetiva.</span>}
                </td>
            </tr>)}</tbody>
        </ResponsiveTable>
    </div>;
}
